import { Entidad } from "../../../../data/Entidad";
import { _SvAlumnoEdoCtaNuevoPagoMultiple } from '../../../../data/modulo/FinanzasEstadoCuenta';
import _L from "../../../../util/Labels";
import { _ModalInfoDataList } from "../../../controlD3/ModalThings/ModalInfoDataList";
import { _ModalToALongProccess } from "../../../controlD3/ModalThings/ModalToALongProccess";
import { NotificacionV2 } from "../../../controlD3/NotificacionV2";
import { SelectV2 } from "../../../controlD3/SelectV2";
import { UIUtilTime } from "../../../util/Time";
import { AlumnoEdoCtaUtil } from "../AlumnoEdoCtaUtil";
import { ProcesoPago1SelectChargesView } from './ProcesoPago1SelectChargesView';
import { ProcesoPago2PartialPaymentView } from './ProcesoPago2PartialPaymentView';
import { ProcesoPago3FinalDetailView } from './ProcesoPago3FinalDetailView';
import { ProcesoPago4DateAndMethodView } from "./ProcesoPago4DateAndMethodView";
import { AlEdoCtaPagoFormUtil } from './Util';

import CTipoPago = Entidad.CTipoPago;
import CTipoProcesoPago = AlEdoCtaPagoFormUtil.CTipoProcesoPago;

type IMovimiento = AlEdoCtaPagoFormUtil.IMovimiento;
type AlumnoEdoCtaPagoFormConfig = AlEdoCtaPagoFormUtil.AlumnoEdoCtaPagoFormConfig;


export function _OpenModal_ProcesoPago(config: AlumnoEdoCtaPagoFormConfig) {
    type IDataForm = AlEdoCtaPagoFormUtil.IDataForm;

    config.PreSeleccionados = (config.PreSeleccionados || [])
        .filter(d => AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0);

    const idEscuela = config.Escuela.IdKinder;
    const metodosPagoList = AlumnoEdoCtaUtil.GetMetodosPagoList(idEscuela);
    const info = config.InfoGeneral;

    if (metodosPagoList.length == 0) {
        NotificacionV2._Mostrar(
            _L("panelfinanzasedocuenta.notif_escsinmtdspago")
                .replace("_ESCUELA", config.Escuela?.Nombre),
            "ADVERTENCIA"
        );
        return;
    }

    const fnUpdateProcesoPagoDataFromFormsData = () => {
        const formTipoPago = procesoPagoSelectChargesView._FormTipoPago;
        const formFechaAndMethod = procesoPagoFechaAndMethodPaymentView?._FormData;
        PROCESO_PAGO_DATA.TipoPago = formTipoPago._Data.TipoPago;
        PROCESO_PAGO_DATA.IdsCargosParciales = formTipoPago._Data.IdsCargosParciales;
        PROCESO_PAGO_DATA.IdMetodoPago = formFechaAndMethod?.IdMetodoPago;
        PROCESO_PAGO_DATA.FechaPagoUTC = formFechaAndMethod?.FechaPagoUTC;
    }

    const PROCESO_PAGO_DATA = <IDataForm>{
        TipoPago: (config.PreSeleccionados.length ? CTipoProcesoPago.PagoParcial : null),
        IdsCargosParciales: config.PreSeleccionados.map(d => d.Id),
        FechaPagoUTC: null,
    };

    let procesoPagoSelectChargesView: ProcesoPago1SelectChargesView;
    let procesoPagoPartialPaymentView: ProcesoPago2PartialPaymentView;
    let procesoPagoVerDetallesView: ProcesoPago3FinalDetailView;
    let procesoPagoFechaAndMethodPaymentView: ProcesoPago4DateAndMethodView;

    _ModalToALongProccess({
        Modulo: AlumnoEdoCtaUtil.MODULO_PERMISO,
        Action: Entidad.CAccionPermiso.RegistrarPagos,
        IdsEscuelas: [idEscuela],
        StartEndIds: ["pay_tipopago", "pay_mtdopago"],
        StepsConfig: [
            {
                // >> Step 1: Selecciona el tipo de pago. Cargos agrupados en:
                // * Pago del saldo total: todos los visibles en la tabla
                // * Pago del saldo del periodo: todos los del periodo filtrado
                // * Pago parcial: solo los que seleccione el usuario
                Id: "pay_tipopago",
                Title: "tag_paycharges",
                NextID: () => (procesoPagoSelectChargesView._FormTipoPago._Data.TipoPago == CTipoProcesoPago.PagoParcial)
                    ? "pay_parcialpagos"
                    : "pay_resumen",
                Width: 420,
                OnDrawContent: (content, mt) => {
                    procesoPagoSelectChargesView = new ProcesoPago1SelectChargesView(
                        mt,
                        config,
                        PROCESO_PAGO_DATA,
                        fnUpdateProcesoPagoDataFromFormsData
                    );
                    content.append(() => procesoPagoSelectChargesView._Node);
                },
                OnValideStep: () => {
                    return procesoPagoSelectChargesView._Valide();
                }
            },
            {
                // >> Step 2: Solo cuando el tipo de pago sea Parcial
                Id: "pay_parcialpagos",
                Title: "tag_payselchargs",
                PreviousID: "pay_tipopago",
                NextID: "pay_resumen",
                Width: 650,
                OnDrawContent: (content, mt) => {
                    procesoPagoPartialPaymentView = new ProcesoPago2PartialPaymentView(PROCESO_PAGO_DATA);
                    content.append(() => procesoPagoPartialPaymentView._DrawView());
                },
                OnFocusContent: (_content, _mt) => {
                    procesoPagoPartialPaymentView._CtrlTblPagosParciales._UpdateData(PROCESO_PAGO_DATA.CargosToPay);
                },
                OnValideStep: (_content, _mt) => {
                    return procesoPagoPartialPaymentView._Valide();
                }
            },
            {
                // >> Step 3: Resumen del pago a aplicar
                Id: "pay_resumen",
                Title: "", // "tag_pay_resum",
                PreviousID: () => ((procesoPagoSelectChargesView._FormTipoPago._Data.TipoPago == CTipoProcesoPago.PagoParcial) ? "pay_parcialpagos" : "pay_tipopago"),
                NextID: "pay_mtdopago",
                Width: 560,
                OnDrawContent: (content, mt) => {
                    procesoPagoVerDetallesView = new ProcesoPago3FinalDetailView(mt, info, PROCESO_PAGO_DATA, procesoPagoSelectChargesView._FormTipoPago);
                },
                OnFocusContent: (content, mt) => {
                    content.html("");
                    content.append(() => procesoPagoVerDetallesView._DrawView());
                }
            },
            {
                // >> Step 4: Selección del método de pago (último paso)
                Id: "pay_mtdopago",
                Title: "tag_procesopago_metodo&fecha",
                PreviousID: "pay_resumen",
                Width: 400,
                OnDrawContent: (content, mt) => {
                    procesoPagoFechaAndMethodPaymentView = new ProcesoPago4DateAndMethodView(
                        mt,
                        PROCESO_PAGO_DATA,
                        metodosPagoList);
                    content.append(() => procesoPagoFechaAndMethodPaymentView._Node);
                },
                OnFocusContent: (_content, mt) => {
                    setTimeout(() => mt.BtnRight.text(_L("panelfinanzasedocuenta.tag_procesopago_registrarpago")));

                    const formData = procesoPagoFechaAndMethodPaymentView._FormData;
                    const formControls = procesoPagoFechaAndMethodPaymentView._FormControls;
                    if (formData.IdMetodoPago) return;
                    setTimeout(() => {
                        (formControls.get("IdMetodoPago").instance as SelectV2)._showOptionsList();
                    }, 200);
                },
                OnValideStep: () => procesoPagoFechaAndMethodPaymentView._Valide(),
                OnAccept: async (mt) => {
                    fnUpdateProcesoPagoDataFromFormsData();
                    // console.warn(procesoPagoData);
                    const res = await Sv_RegistrarPagosMultiple(PROCESO_PAGO_DATA);
                    const someCargosPagados = [-2, -3].includes(res.Resultado);
                    if (res.Resultado > 0 || someCargosPagados) {

                        config.OnAccept_SuccessPays()

                        if (someCargosPagados) {
                            mt.Modal._Ocultar();
                        }
                    }
                    return res;
                }
            }
        ],
        OnClose: () => {
            config.OnClose();
        }
    });


    function Sv_RegistrarPagosMultiple({ IdMetodoPago, FechaPagoUTC, CargosToPay }: AlEdoCtaPagoFormUtil.IDataForm) {
        return _SvAlumnoEdoCtaNuevoPagoMultiple(
            IdMetodoPago,
            FechaPagoUTC,
            CargosToPay.map(d => {
                return {
                    Id: d.Cargo.Id,
                    Monto: d.Pago,
                    TipoPago: ((d.Pago == AlumnoEdoCtaUtil.GetSaldoMovimiento(d.Cargo)) ? CTipoPago.PagoCompleto : CTipoPago.PagoParcial)
                }
            })
        ).then(res => {
            if (res.Resultado == -6) {
                _ModalInfoDataList({
                    Title: _L("general.failresume"),
                    InfoText: _L("panelfinanzasedocuenta.tag_procesopago_err_fechapago_7", UIUtilTime._DateFormatStandar(FechaPagoUTC, "dd/mm/yyyy h24:mm")),
                    DataList: res.DetalleError || [],
                    OnStepItemData: (content, itemData) => {
                        const mov = CargosToPay.find(d => d.Cargo.Id == itemData.IdPadre);
                        content.text(
                            `${_L("panelfinanzasedocuenta.d_field_descripcion")}: ${mov.Cargo.Cargo}`
                            + `\n${_L("panelfinanzasedocuenta.tag_procesopago_ultfechapago")}: ${UIUtilTime._DateFormatStandar(itemData.UltimaFechaPago, "dd/mm/yyyy h24:mm")}`
                        )
                    }
                })
            }
            return res;
        });
    }
}